<template>
  <div id="wallet" class="margin-10">
    <div class="padding-5"></div>
    <div class="wallet-cards-wrapper">
      <div v-if="walletData.length || referralData.length">
        <div class="wallet-wrapper box-shadow radius-5 margin-bottom-10" v-for="wl in walletData">
          <div class="wallet-header-bg padding-10">
            <div class="align-hor center-ver space-between bg-grey margin-bottom-10">
              <div class="align-hor center-ver">
                <div v-if="wl.reward_icon">
                  <img class="semi-medium-icon margin-right-5" :src="wl.reward_icon" alt="cash-reward">
                </div>
                <div class="text-left">
                  <div class="text-semi-small">Balance</div>
                  <div class="font-bold">{{formatReward(wl.reward_type, wl.balance, true)}}</div>
                </div>
              </div>
              <div class="wrap align-hor center-ver center-hor padding-0510 radius-5 text-light pointer" @click="redirectTo((wl.reward_type == 'Cash' ? 'redeem' : 'gift-cards'), {bal: wl.balance})" :style="{background: bgTheme}" v-if="wl.is_redeemable">
               <div><!-- <img class="smaller-icon pull-left margin-right-5" src="@/assets/gift-box-o.svg">--> Redeem</div>
              </div>
              <div class="wrap align-hor center-ver center-hor padding-0510 radius-5 text-light pointer" :style="{background: ((wl.reward_type != 'Cash') ? bgTheme : '#CCCCCC')}" v-else-if="(wl.reward_type == 'Cash') || (wl.reward_type == active_currency.label)" @click="((wl.reward_type != 'Cash') ? redirectTo('gift-cards') : '')">
                <div><!--<img class="smaller-icon pull-left margin-right-5" src="@/assets/gift-box-o.svg">--> Redeem</div>
              </div>
            </div>
            <div class="text-left text-semi-small" v-if="(wl.wallet_message && wl.wallet_message != '')">{{wl.wallet_message}}</div>
          </div>
          <div class="bg-light padding-vertical-10">
            <div class="align-hor center-ver space-between padding-vertical-5" style="padding: 10px 0">
              <p>Total Earned</p>
              <p>{{formatReward(wl.reward_type, wl.total_earned, true)}}</p>
            </div>
            <div class="align-hor center-ver space-between padding-vertical-5 padding-horizontal-10">
              <p>Total Redeemed</p>
              <p>{{formatReward(wl.reward_type, wl.total_redeemed,true)}}</p>
<!--              <p v-else>0</p>-->
            </div>
          </div>
          <div class="wallet-header-bg padding-10 text-large text-underline text-right pointer" v-on:click="redirectTo('transactions', {type: wl.reward_type, is_redeemable: wl.is_redeemable})">All Transaction</div>
        </div>

        <div class="wallet-wrapper box-shadow radius-5 margin-bottom-10" v-if="referralData.length">
          <div class="wallet-header-bg padding-10">
            <div class="align-hor center-ver space-between bg-grey">
              <div class="align-hor center-ver">
                <div class="align-hor center-ver">
                  <img class="extra-medium-icon margin-right-5" src="@/assets/referral.svg" alt="cash-reward">
                </div>
                <div class="text-left">
                  <div class="font-bold">Referrals</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-light padding-10">
            <div class="align-hor center-ver space-between" v-for="ref in referralData">
              <p>Total {{ref.prize_type}} Earned from Referrals</p>
              <p>{{formatReward(ref.prize_type, ref.total_value,  true )}}</p>
            </div>
          </div>
          <div class="wallet-header-bg padding-10 text-small text-underline text-right pointer" @click="redirectTo('referrals')">History</div>
        </div>
      </div>

      <div class="wallet-wrapper box-shadow margin-bottom-10" v-if="walletData.length == 0 && referralData.length == 0 && showShimmer" v-for="$i in 2">
        <div class="align-hor center-ver space-between wallet-header-bg padding-10">
          <div class="w50">
            <div class="align-hor center-ver margin-bottom-10">
              <div class="w20 margin-right-10">
                <div class="wrapper">
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
              <div class="w40">
                <div class="wrapper">
                  <div class="comment animate margin-bottom-5"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
            </div>
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
          <div class="w20">
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>

        <div class="align-hor center-ver space-between bg-light padding-10 bottom-border" v-for="$j in 2">
          <div class="w40">
            <div class="padding-horizontal-10">
              <div class="wrapper">
                <div class="comment animate"></div>
              </div>
            </div>
          </div>
          <div class="w10">
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
        </div>

        <div class="align-hor center-ver end-hor wallet-header-bg padding-10">
          <div class="w20">
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver" style="min-height: 80vh" v-if="walletData.length == 0 && referralData.length == 0 && !showShimmer">
        <img class="extra-large-icon margin-bottom-20" src="@/assets/no-data.svg">
        <div>Nothing to show</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { globals } from "@/mixins/globals"
  import axios from 'axios';
  export default {
    mixins: [globals],
    data() {
      return {
        walletData: [],
        referralData: [],
        is_shimmer: true,
        active_currency: {}
      }
    },

    beforeMount() {
      this.loadDataFromCookie();
    },
    computed: {
      allTransactions: function() {
        return this.transactions;
      },
      showShimmer: function() {
        return this.is_shimmer;
      }
    },
    methods: {
      getWalletData() {
        axios.all([this.getWalletInfo()])
        .then(axios.spread((resp) => {
          if(resp.data.success) {
            var data = resp.data;
            if((data.wallet_data && data.wallet_data.length > 0) || (data.referral_data && data.referral_data.length > 0)) {
              this.walletData = resp.data.wallet_data;
              this.referralData = resp.data.referral_data;
              this.active_currency = resp.data.active_currency;
            } else {
              this.is_shimmer = false;
            }
          } else {
            this.is_shimmer = false;
          }
        })).catch((err) => {});
      }
    },
    created() {
      var store_state = this.$store.state;
      store_state.headTitle = "Wallet";
      store_state.showHeader = true;
      store_state.showHistory = false;
      store_state.showWallet = false;
      store_state.user.headerBalance.show = false;
      this.loadDataFromCookie();
      this.getWalletData();
    }
  }
</script>

<style>
  .small-reward-icon {
    width: 20px;
    margin-right: 5px;
  }

  .transaction-bg {
    background: #FFFFFF;
    margin-left: 5px;
    margin-right: 5px;
    box-shadow: 0 0 5px rgba(0,0,0,.2);
  }

  .wallet-header-bg {
    background: #F7F7F7;
  }
</style>



// WEBPACK FOOTER //
// src/screens/wallet.vue